// Данный файл - лишь собрание подключений готовых компонентов.
// Рекомендуется создавать отдельный файл в папке components и подключать все там

// Подключение свайпера
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";
import {addClass, removeClass} from "./_vars";
import Swiper, {Autoplay, Navigation, Pagination, EffectFade, Lazy} from "swiper";
import LazyLinePainter from "lazy-line-painter";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Lazy]);
function init() {
   const sliderSettings = {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 16,
      virtual: {
         enabled: true,
      },
      breakpoints: {
         1: {
            slidesPerView: 1.1,
         },
         767: {
            slidesPerView: 2.1,
         },
         991: {
            slidesPerView: 2.8,
         },
         1100: {
            slidesPerView: 3.5,
         },
         1280: {
            slidesPerView: 4,
         },
      },
   };
   function updateSliders() {
      new Swiper(".clients-slider", {
         ...sliderSettings,
         navigation: {
            nextEl: ".clients-slider__next.swiper-button-next",
            prevEl: ".clients-slider__prev.swiper-button-prev",
         },
      });
      new Swiper(".our-slider", sliderSettings);
      new Swiper(".cooperation-slider", sliderSettings);
      new Swiper(".and-slider.col-2", {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         breakpoints: {
            1: {
               slidesPerView: 1.2,
               spaceBetween: 0,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            767: {
               slidesPerView: 2.1,
               spaceBetween: 16,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            991: {
               slidesPerView: 2,
               spaceBetween: 0,
               allowSlideNext: false,
               allowTouchMove: false,
               allowSlidePrev: false,
            },
         },
         navigation: {
            nextEl: ".and-slider__next.swiper-button-next",
            prevEl: ".and-slider__prev.swiper-button-prev",
         },
      });
      new Swiper(".and-slider.col-3", {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         breakpoints: {
            1: {
               slidesPerView: 1.2,
               spaceBetween: 0,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            767: {
               slidesPerView: 2.1,
               spaceBetween: 16,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            991: {
               slidesPerView: 3,
               spaceBetween: 0,
               allowSlideNext: false,
               allowTouchMove: false,
               allowSlidePrev: false,
            },
         },
         navigation: {
            nextEl: ".and-slider__next.swiper-button-next",
            prevEl: ".and-slider__prev.swiper-button-prev",
         },
      });
      new Swiper(".rule-slider", {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         breakpoints: {
            1: {
               slidesPerView: 1.2,
               spaceBetween: 0,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            767: {
               slidesPerView: 2.1,
               spaceBetween: 16,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            991: {
               slidesPerView: 2,
               spaceBetween: 0,
               allowSlideNext: false,
               allowTouchMove: false,
               allowSlidePrev: false,
            },
         },
         navigation: {
            nextEl: ".rule-slider__next.swiper-button-next",
            prevEl: ".rule-slider__prev.swiper-button-prev",
         },
      });
      new Swiper(".create__items", {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         breakpoints: {
            1: {
               slidesPerView: 1.1,
               spaceBetween: 8,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            767: {
               slidesPerView: 1.5,
               spaceBetween: 8,
               allowSlideNext: true,
               allowTouchMove: true,
               allowSlidePrev: true,
            },
            1000: {
               slidesPerView: "auto",
               spaceBetween: 0,
               allowSlideNext: false,
               allowTouchMove: false,
               allowSlidePrev: false,
            },
         },
      });
   }
   updateSliders();
   window.addEventListener("resize", function (event) {
      updateSliders();
   });

   const servicesSlider = document.querySelector(".services-slider");
   if (servicesSlider) {
      new Swiper(servicesSlider, {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         spaceBetween: 8,
         // breakpoints: {
         // 1: {
         //     slidesPerView: 1.1,
         // },

         // 767: {
         //     slidesPerView: 2.5,
         // },
         // 991: {
         slidesPerView: "auto",
         // },
         // },
         navigation: {
            nextEl: ".services-slider__next.swiper-button-next",
            prevEl: ".services-slider__prev.swiper-button-prev",
         },
      });
   }

   new Swiper(".know-slider", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      breakpoints: {
         1: {
            slidesPerView: 1.1,
            spaceBetween: 8,
         },
         525: {
            slidesPerView: 1.6,
            spaceBetween: 8,
         },
         767: {
            slidesPerView: 2,
            spaceBetween: 8,
         },
         1001: {
            slidesPerView: 6,
         },
      },
   });
   new Swiper(".know-slider-crm", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      breakpoints: {
         1: {
            slidesPerView: 1.1,
            spaceBetween: 8,
         },
         525: {
            slidesPerView: 1.6,
            spaceBetween: 8,
         },
         767: {
            slidesPerView: 2,
            spaceBetween: 8,
         },
      },
   });
   new Swiper(".ready-slider", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 8,
      breakpoints: {
         1: {
            slidesPerView: 1.2,
         },
         525: {
            slidesPerView: 1.6,
         },
         767: {
            slidesPerView: 2,
         },
         991: {
            slidesPerView: 3.5,
         },
         1100: {
            slidesPerView: 4,
         },
      },
   });
   new Swiper(".ready-slider-5", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 8,
      breakpoints: {
         1: {
            slidesPerView: 1.2,
         },
         525: {
            slidesPerView: 1.6,
         },
         767: {
            slidesPerView: 2,
         },
         991: {
            slidesPerView: 3.5,
         },
         1100: {
            slidesPerView: 5,
         },
      },
   });
   new Swiper(".ready-slider_audit", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 8,
      breakpoints: {
         1: {
            slidesPerView: 1.2,
         },
         525: {
            slidesPerView: 1.6,
         },
         767: {
            slidesPerView: 2,
         },
         991: {
            slidesPerView: 3,
         },
      },
   });
   new Swiper(".trust-slider", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 8,
      breakpoints: {
         1: {
            slidesPerView: 1.1,
         },
         525: {
            slidesPerView: 1.4,
         },
         767: {
            slidesPerView: 1.5,
         },
         991: {
            slidesPerView: 2.45,
         },
         1100: {
            slidesPerView: 3.1,
         },
      },
      navigation: {
         nextEl: ".trust-slider__next.swiper-button-next",
         prevEl: ".trust-slider__prev.swiper-button-prev",
      },
   });
   new Swiper(".marquee-slider", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 4,
      centeredSlides: true,
      speed: 8000,
      autoplay: {
         delay: 0,
         disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: "auto",
      grabCursor: false,
   });

   new Swiper(".made-slider", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      navigation: {
         nextEl: ".made__next.swiper-button-next",
         prevEl: ".made__prev.swiper-button-prev",
      },
      breakpoints: {
         1: {
            slidesPerView: 1.8,
            spaceBetween: 16,
            allowSlideNext: true,
            allowTouchMove: true,
            allowSlidePrev: true,
         },
         525: {
            slidesPerView: 2.4,
            spaceBetween: 16,
            allowSlideNext: true,
            allowTouchMove: true,
            allowSlidePrev: true,
         },
         767: {
            slidesPerView: 3,
            spaceBetween: 16,
            allowSlideNext: true,
            allowTouchMove: true,
            allowSlidePrev: true,
         },
         991: {
            slidesPerView: 4,
            spaceBetween: 16,
         },
         1281: {
            slidesPerView: 5,
            spaceBetween: 16,
         }
      },
   });

   const proudSlider = new Swiper(".proud__switchers", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      slidesPerView: "auto",
      spaceBetween: 8,
      on: {
         click() {
            handleClickedSlide(this);
         },
      },
   });
   slideToActive(proudSlider);
   function slideToActive(swiper) {
      const slides = [...swiper.slides]
      for (let i = 0; i < slides.length; i++) {
         const slide = slides[i];
         if (slide.classList.contains("--active")) {
            swiper.slideTo(i);
            break;
         }
      }
   }

   function handleClickedSlide(swiper) {
      const swiperRect = swiper.el.getBoundingClientRect();
      const slideRect = swiper.clickedSlide.getBoundingClientRect();
      const isRight = swiperRect.right < slideRect.right;
      const isLeft = swiperRect.left > slideRect.left;

      if (isRight) swiper.slideNext();
      if (isLeft) swiper.slidePrev();
   }
   const casesSwitcher = new Swiper(".cases__switchers", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      slidesPerView: "auto",
      spaceBetween: 0,
      on: {
         click() {
            handleClickedSlide(this);
         },
      },
   });
   const declarationSliders = document.querySelectorAll(".declaration-slider");
   declarationSliders.forEach((slider) => {
      const nextBtn = slider.querySelector(
         ".declaration-slider__next.swiper-button-next"
      );
      const prevBtn = slider.querySelector(
         ".declaration-slider__prev.swiper-button-prev"
      );
      new Swiper(slider, {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         slidesPerView: 1,
         spaceBetween: 24,
         loop: true,
         navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
         },
      });
   });
   const customersSliders = document.querySelectorAll(".customers-slider");
   [...customersSliders].forEach(slider => {
      const nextEl = slider?.closest("section")?.querySelector(".swiper-button-next");
      const prevEl = slider?.closest("section")?.querySelector(".swiper-button-prev");
      new Swiper(slider, {
         preloadImages: false,
         lazy: {
            checkInView: true,
            loadPrevNext: true,
            loadPrevNextAmount: 10,
         },
         slidesPerView: "auto",
         spaceBetween: 8,
         navigation: {
            nextEl: nextEl,
            prevEl: prevEl
         }
      });
   });
   new Swiper(".houses", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
         crossFade: true
      },
      navigation: {
         nextEl: ".houses-slider__next.swiper-button-next",
         prevEl: ".houses-slider__prev.swiper-button-prev",
      },
   });
   new Swiper(".during__grid", {
      preloadImages: false,
      lazy: {
         checkInView: true,
         loadPrevNext: true,
         loadPrevNextAmount: 10,
      },
      spaceBetween: 8,
      breakpoints: {
         1000: {
            slidesPerView: "auto",
         },
         1400: {
            slidesPerView: 4,
         },
      },
   });

   // ANIMATIONS
   function gsapAnimations() {
      gsap.registerPlugin(ScrollTrigger);
      const itemSteps = document.querySelectorAll(".item-steps");
      if (itemSteps) [...itemSteps].forEach(element => {
         gsap.timeline({
            scrollTrigger: {
               trigger: element,
               start: "top center",
               end: "bottom top",
               onEnter(self) {
                  self.trigger.classList.add("--active");
               },
            },
         });
      });
      const drainItemsBlocks = document.querySelectorAll(".drain__items");
      if (drainItemsBlocks) drainItemsBlocks.forEach(block => {
         gsap.timeline({
            scrollTrigger: {
               trigger: block,
               start: "top center",
               end: "bottom top",
               onEnter({trigger}) {
                  if (!trigger._app_.drainAnimation.isPlayed) trigger._app_.drainAnimation.animate();
               },
            },
         });

      });
      const hero = document.querySelector(".hero");
      if (hero) {
         const nextEl = hero.nextElementSibling;
         if (nextEl) {
            nextEl.style.opacity = "0";
            nextEl.style.transform = "translateY(25%)";
            nextEl.style.transition = "0.5s ease 0s";
            gsap.timeline({
               scrollTrigger: {
                  trigger: ".hero",
                  start: "top+=200px top",
                  onEnter() {
                     nextEl.style.transform = "translateY(0%)";
                     nextEl.style.opacity = "1";
                  },
               },
            });
         }
      }
      if (document.querySelector(".gift")) {
         gsap.from(".gift-phone.--desktop", {
            yPercent: 150,
            ease: "none",
            scrollTrigger: {
               trigger:
                  document.querySelector(".gift").previousElementSibling,
               start: "-100px center",
               scrub: 0.5,
               end: "bottom",
            },
         });
         gsap.from(".gift-union.--desktop", {
            yPercent: 80,
            ease: "none",
            scrollTrigger: {
               trigger: ".our",
               scrub: 0.5,
               end: "bottom",
            },
         });
         gsap.from(".gift-bounce.--desktop", {
            yPercent: 50,
            ease: "none",
            scrollTrigger: {
               trigger: ".our",
               scrub: 0.5,
               end: "bottom",
            },
         });
         gsap.from(".gift-square.--desktop", {
            yPercent: 70,
            ease: "none",
            scrollTrigger: {
               trigger: ".our",
               scrub: 0.5,
               end: "bottom",
            },
         });
      }
      if (document.querySelector(".team")) {
         gsap.from(".team__union-first", {
            yPercent: 100,
            ease: "none",
            rotate: 0,
            scrollTrigger: {
               trigger: ".team",
               scrub: 0.5,
               end: "bottom",
            },
         });
         gsap.from(".team__union-second", {
            yPercent: -200,
            ease: "none",
            rotate: 0,
            scrollTrigger: {
               trigger: ".team",
               scrub: 0.5,
               end: "bottom",
            },
         });
      }
      if (document.querySelector(".rocket")) {
         gsap.fromTo(
            ".rocket__image",
            {
               yPercent: 50,
               scrollTrigger: {
                  trigger: ".rocket",
                  scrub: true,
                  end: "bottom",
                  duration: 10000,
                  ease: "Power3.easeInOut",
               },
            },
            {
               yPercent: -100,
               scrollTrigger: {
                  trigger: ".rocket",
                  scrub: true,
                  end: "bottom",
                  duration: 10000,
                  ease: "Power3.easeInOut",
               },
            }
         );

         gsap.fromTo(
            ".rocket__text",
            {
               xPercent: 150,
               scrollTrigger: {
                  trigger: ".rocket",
                  scrub: true,
                  start: "top+=20 center",
                  end: "bottom",
                  duration: 10000,
                  ease: "Power3.easeInOut",
               },
            },
            {
               xPercent: -150,
               scrollTrigger: {
                  trigger: ".rocket",
                  scrub: true,
                  start: "top+=20 center",
                  end: "bottom",
                  duration: 10000,
                  ease: "Power3.easeInOut",
               },
            }
         );
         gsap.to(".rocket__cloud.--first", {
            yPercent: -250,
            ease: "none",
            scrollTrigger: {
               trigger: ".rocket",
               scrub: 0.5,
               end: "bottom",
            },
         });
         gsap.fromTo(
            ".rocket__cloud.--second",
            {
               y: -600,
               scrollTrigger: {
                  trigger: ".rocket",
                  scrub: true,
                  end: "bottom",
                  duration: 10000,
                  ease: "Power3.easeInOut",
               },
            },
            {
               y: 600,
               scrollTrigger: {
                  trigger: ".rocket",
                  scrub: true,
                  end: "bottom",
                  duration: 10000,
                  ease: "Power3.easeInOut",
               },
            }
         );
      }
      if (document.querySelector(".ready")) {
         gsap.from(".ready-item.--second", {
            yPercent: 100,
            ease: "none",
            scrollTrigger: {
               trigger: ".ready",
               scrub: 0.5,
               end: "top",
            },
         });
         gsap.from(".ready-item.--third", {
            yPercent: 150,
            ease: "none",
            scrollTrigger: {
               trigger: ".ready",
               scrub: 0.5,
               end: "top",
            },
         });
         gsap.from(".ready-item.--fourth", {
            yPercent: 50,
            ease: "none",
            scrollTrigger: {
               trigger: ".ready",
               scrub: 0.5,
               end: "top",
            },
         });
         gsap.from(".ready-item.--fifth", {
            yPercent: 80,
            ease: "none",
            scrollTrigger: {
               trigger: ".ready",
               scrub: 0.5,
               end: "top",
            },
         });
      }

      const result = document.querySelector(".result");
      if (result) {
         gsap.fromTo(".result__play",
            {
               x: "-150%",
               scrollTrigger: {
                  trigger: ".result",
                  scrub: 0.5,
                  end: "bottom bottom",
               },
            },
            {
               x: 0,
               scrollTrigger: {
                  trigger: ".result",
                  scrub: 0.5,
                  end: "bottom bottom",
               },
            }
         );
         gsap.fromTo(".result__real",
            {
               x: "150%",
               scrollTrigger: {
                  trigger: ".result",
                  scrub: 0.5,
                  end: "bottom bottom",
               },
            },
            {
               x: 0,
               scrollTrigger: {
                  trigger: ".result",
                  scrub: 0.5,
                  end: "bottom bottom",
               },
            }
         );
      }
      const animations = [...document.querySelectorAll(".appear")];
      animations.forEach((animation) => {
         const tlChoose = gsap.timeline({
            scrollTrigger: {
               trigger: animation,
               start: "200px bottom",
               end: "bottom top",
               onEnter() {
                  animation.classList.add("--visible");
               },
            },
         });
      });
      const svgAnimate = [...document.querySelectorAll(".svg-animate")];
      svgAnimate.forEach((svg) => {
         svg.lazyLinePainter = new LazyLinePainter(svg, {strokeWidth: 0});
         const section = svg.closest(".section");
         gsap.timeline({
            scrollTrigger: {
               trigger: section || svg,
               start: "top center",
               end: "bottom top",
               onToggle(self) {
                  if (!svg.svgAnimExploded && self.isActive) {
                     svg.svgAnimExploded = true;
                     svg.lazyLinePainter.paint();
                  }
               },
            },
         });
      });
      const scrollTgl = [...document.querySelectorAll(".scroll-tgl")];
      scrollTgl.forEach((animation) => {
         const tlChoose = gsap.timeline({
            scrollTrigger: {
               trigger: animation,
               start: "400px bottom",
               end: "bottom top",
               onEnter() {
                  animation.classList.add("--scroll-act");
               },
            },
         });
      });

      if (document.querySelector(".attention")) {
         gsap.fromTo(
            ".attention__decor_1",
            {
               rotate: -13,
               scrollTrigger: {
                  end: "bottom center",
                  trigger: ".attention__decor_1 span",
                  scrub: 0.5,
               },
            },
            {
               rotate: 16,
               scrollTrigger: {
                  end: "bottom center",
                  trigger: ".attention__decor_1 span",
                  scrub: 0.5,
               },
            }
         );
         const animDetail = (selector, frames) => {
            const offset = window.innerWidth <= 1440 ? 1 : (window.innerWidth / 1440) * 1.5;
            return gsap.fromTo(
               selector,
               {
                  y: 0,
                  scrollTrigger: {
                     trigger: selector,
                     scrub: 0.5,
                     // start: `top-=${Math.abs(frames[1] - frames[0]) * 3} bottom`,
                     end: "bottom center-=200",
                  },
               },
               {
                  scrollTrigger: {
                     trigger: selector,
                     scrub: 0.5,
                     // start: `top-=${Math.abs(frames[1] - frames[0]) * 3} bottom`,
                     end: "bottom center-=200",
                  },
                  keyframes: [
                     {
                        y: (frames[1] - frames[0]) * offset,
                     },
                     {
                        y: (frames[2] - frames[0]) * offset,
                     },
                  ],
               }
            );
         };
         if (window.innerWidth <= 767) {
            animDetail(".attention__decor_2", [425.5, 335.5, 414]);
            animDetail(".attention__decor_3", [237, 218, 228.5]);
            animDetail(".attention__decor_4", [71, 36, 60]);
            animDetail(".attention__decor_5", [113.5, 120.5, 65]);
            animDetail(".attention__decor_6", [323.5, 348.5, 367]);
            animDetail(".attention__decor_7", [106.5, 94, 113]);
            animDetail(".attention__decor_8", [-38, -29.5, -43.5]);
            animDetail(".attention__decor_9", [166, 186, 178.5]);
            animDetail(".attention__decor_10", [63, 54, 44.5]);
            animDetail(".attention__decor_11", [374, 361, 343]);
            animDetail(".attention__hit", [489, 474, 498.5]);
            animDetail(".attention__sub-title>span:last-child", [257, 260, 257.5]);
         } else {
            animDetail(".attention__decor_2", [851, 671, 828]);
            animDetail(".attention__decor_3", [474, 436, 457]);
            animDetail(".attention__decor_4", [142, 72, 120]);
            animDetail(".attention__decor_5", [227, 241, 130]);
            animDetail(".attention__decor_6", [647, 697, 734]);
            animDetail(".attention__decor_7", [213, 188, 226]);
            animDetail(".attention__decor_8", [-76, -59, -87]);
            animDetail(".attention__decor_9", [332, 372, 357]);
            animDetail(".attention__decor_10", [126, 108, 89]);
            animDetail(".attention__decor_11", [748, 722, 686]);
            animDetail(".attention__hit", [978, 948, 997]);
            animDetail(".attention__sub-title>span:last-child", [514, 520, 515]);
         }
      }
   }

   gsapAnimations();
   const animations = document.querySelectorAll(".appear");

   const options = {
      rootMargin: "-200px 0px 0px 0px",
      threshold: 0.4,
   };

   const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
         if (entry.isIntersecting) {
            entry.target.classList.add("--visible");

            observer.unobserve(entry.target);
         }
      });
   };

   const observer = new IntersectionObserver(observerCallback, options);

   animations.forEach((animation) => {
      observer.observe(animation);
   });
   const iframeCases = document.querySelectorAll(".work-frame__inner");
   [...iframeCases].forEach(iframe => {
      function setIframeSize(width, height) {
         iframe.style.width = "";
         iframe.style.transform = "";
         if (iframe.offsetWidth && iframe.offsetWidth !== width) {
            const initialWidth = iframe.offsetWidth;
            const scale = initialWidth / width;
            iframe.style.width = `${width}px`;
            iframe.style.height = `${height}px`;
            iframe.style.transform = `scale(${scale})`;
         }
      }
      function resizeIframe() {
         if (innerWidth >= 577) setIframeSize(1920, 1219);
         else setIframeSize(394, 845);
      }
      const parent = iframe.parentElement;
      const resizeObserver = new ResizeObserver(() => resizeIframe);
      resizeObserver.observe(parent);
      addEventListener("resize", resizeIframe);
      resizeIframe()
   });
}
if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);

import {Fancybox} from "@fancyapps/ui";

Fancybox.bind('[data-fancybox="till-image"]');
Fancybox.bind('[data-fancybox="till-image-2"]');
Fancybox.bind('[data-fancybox="launch-image"]');
